import { call, put } from 'redux-saga/effects';
import { getDeclarationDocumentsError, getDeclarationDocumentsSuccess } from '../redux/actions';
import { getDeclarationDocuments } from 'modules/Declarations/services/api';

export function* getDeclarationsDocumentsSaga({ payload: { cardId, type } }) {
  if (!cardId) {
    return;
  }
  const { isOk, error, data } = yield call(getDeclarationDocuments, cardId, type);
  if (isOk) {
    return yield put(getDeclarationDocumentsSuccess(cardId, data));
  }
  return yield put(getDeclarationDocumentsError(cardId, error));
}
